module.exports = __webpack_public_path__ + "images/cfair-6338b246c5771415b4d7c948616f80f8.png";